<!--
 * @Author: Niklaus
 * @Date: 2026-04-24 14:39:01
 * @LastEditTime: 2026-05-08 09:28:27
 * @LastEditors: Niklaus
 * @Description: 当前年度企业入驻退出数据
-->
<template>
    <basic-container isCard :body-style="{ padding: '0', height: '100%' }" class="h-100p">
        <!-- 自写查询数 -->
        <el-form :inline="true" label-width="80px" class="wid-100">
            <el-form-item label="企业名称">
                <el-input v-model="form.name" size="medium"></el-input>
            </el-form-item>
            <el-form-item label="时间" v-if="type == 'Y'">
                <el-date-picker size="medium" class="w-100p" v-model="form.create_time" :unlink-panels="true"
                    value-format="yyyy-MM-dd" type="daterange" range-separator="-" start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onLoad" size="medium">搜 索</el-button>
                <el-button @click="reset" size="medium">重 置</el-button>
            </el-form-item>

        </el-form>
        <div class="h-100p">
            <avue-crud :option="option" :table-loading="loading" :data="data" ref="crud" :page.sync="page"
                @on-load="onLoad" class="custom">
                <template slot="menuLeft" slot-scope="scope">
                    <el-button size="small" type="primary" icon="el-icon-download" @click="exportData()">导出
                    </el-button>
                </template>
            </avue-crud>

        </div>
    </basic-container>
</template>
<script>
import dayjs, { Dayjs } from "dayjs"
import { getWeek } from '@/util/date'
import * as dictService from "@/api/system/dictbiz";
import { getMetaCommonList, getMetaCommonListExport } from '@/api/busiMode/metaCommon';
export default {
    data() {
        return {
            loading: true,
            page: {
                size: 10,
                current: 1,
                total: 0,
            },
            form: { name: '', create_time: [] },
            option: {
                dateBtn: false,
                border: true,
                height: 'auto',
                tip: true,
                searchShowBtn: false,
                searchMenu: false,
                searchShow: false,
                addBtn: false,
                refreshBtn: false,
                addRowBtn: false,
                columnBtn: false,
                rowKey: '',
                showPage: true,
                index: true,
                indexLabel: '序号',
                selection: false,
                showHeader: true,
                expand: false,
                highlightCurrentRow: true,
                stripe: false,
                menu: false,
                column: [
                    {
                        align: 'left',
                        label: '企业名称',
                        prop: 'name',
                        search: true,
                        searchSpan: 6,
                    },
                    {
                        align: 'left',
                        label: this.type == '' ? '时间' : this.type == '1' ? '入驻时间' : '退出时间',
                        searchLabelWidth: 120,
                        prop: 'create_time',
                        searchSpan: 6,
                        search: true,
                        type: "date",
                        format: "yyyy-MM-dd HH:mm:ss",
                        valueFormat: "yyyy-MM-dd",
                        searchRange: true,
                    },
                    {
                        align: 'left',
                        label: '类型',
                        prop: 'approval_type',
                        width: 220,
                        search: true,
                        searchSpan: 6,
                        hide: this.type == '' ? true : false,
                        type: "select",
                        dataType: "number",
                        dicUrl: dictService.getUrl("approvalType"),
                        props: {
                            label: "dictValue",
                            value: "dictKey",
                        },
                    },

                    {
                        align: 'left',
                        label: '操作方式',
                        prop: 'process_instance_id',
                        width: 110,
                        formatter: (row, value) => { // 用来格式化列内容
                            return value ? '流程审批' : '直接导入'
                        },
                    }
                ],
            },
            data: [],
        };
    },

    props: {
        table: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: ''
        }
    },
    methods: {

        /**
         * @Author: Niklaus
         * @Description: 获取列表数据
         */
        onLoad() {
            this.loading = true;
            console.log(this.table)
            let body = {
                current: this.page.currentPage || 1,
                size: this.page.pageSize || 10,
                orders: [{ field: "create_time", sort: "DESC" }],
                wheres: this.autoUpdateWheres()
            };
            getMetaCommonList(this.table, body).then(res => {
                const data = res.data.data;
                this.page.total = data.total;
                this.data = data.records;
                this.loading = false;
            });
        },
        /**
         * @Author: Niklaus
         * @Description: 导出数据
         */
        exportData() {
            this.downLoading = true
            let body = {
                current: 1,
                size: 100,
                orders: [{ field: "create_time", sort: "DESC" }],
                wheres: this.autoUpdateWheres()
            };

            getMetaCommonListExport(this.table, body).then((res) => {
                this.downLoading = false
                let url = window.URL.createObjectURL(new Blob([res.data]))
                let a = document.createElement("a")
                a.style.display = "none"
                a.href = url
                a.download = `企业${this.type == '' ? '' : this.type == '1' ? '入驻' : '退出'}明细导出数据.xlsx`
                document.body.appendChild(a)
                a.click()
            })
        },

        /**
         * @Author: Niklaus
         * @Description: 获取指定类型的时间段并查询数据
         * @param {*} type 类型
         */
        getTime(type) {
            if (type == 'LW') {
                let t = getWeek(-1, -2, -2)
                if (t && t.length > 0) {
                    this.formInline.startDate = t[0]
                    this.formInline.endDate = t[1]
                }
            } else if (type == 'W') {
                let t = getWeek(0)
                if (t && t.length > 0) {
                    this.formInline.startDate = t[0]
                    this.formInline.endDate = t[1]
                }
            } else if (type == 'M') {
                this.formInline.startDate = dayjs().startOf('month').format('YYYY-MM-DD')
                this.formInline.endDate = dayjs().endOf('month').format('YYYY-MM-DD')
            } else if (type == 'Y') {
                let y = dayjs().year()
                this.formInline.startDate = y + '-01-01'
                this.formInline.endDate = y + '-12-31'
            }
            this.page.current = 1
            this.onLoad()
        },

        autoUpdateWheres() {
            let wheres = []
            if ((!this.form.name) && (this.form.create_time.length == 0)) return wheres
            Object.keys(this.form).forEach(key => {
                if (this.form[key]) {
                    if (key != 'create_time') {
                        wheres.push({ field: key, op: 'LIKE', value: this.form[key] })
                    } else if (this.form[key].length > 0) {
                        wheres.push({ field: key, op: 'GE', value: this.form[key][0] + ' 00:00:00' })
                        wheres.push({ field: key, op: 'LE', value: this.form[key][1] + ' 23:59:59' })
                    }
                }
            })

            return wheres
        },

        reset() {
            Object.keys(this.form).forEach(key => {
                if (key == 'create_time') {
                    this.form[key] = []
                } else {
                    this.form[key] = ''
                }
            })
        }
    },
}
</script>
<style lang="scss" scoped>
.custom .avue-crud__menu {
    display: none !important;
    height: 0;
    min-height: 0;
}

.demo-form-inline {
    padding: 20px 15px 0 20px;
}
</style>
